export const NOT_SET = undefined;

export const CHART_CONFIG = {
  handleMouseOver: () => {},
  handleMouseOut: () => {},
  handleClick: () => {},
};

export const PALETTE_A = ['#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#e76f51'];

export const PALETTE_B = ['#f94144', '#f3722c', '#f8961e', '#f9c74f', '#90be6d', '#43aa8b', '#577590'];

export const PALETTE_C = ['#e1ca96', '#aca885', '#918b76', '#5dd39e', '#348aa7', '#525174', '#513b56'];
